<ng-template #template>
  <div class="container">
    <form [formGroup]="memberForm" (ngSubmit)="onSubmit()">
      <div class="row px-0 py-5" style="min-height: 800px">
        <div class="p-lg-0 col-lg-12">
          <div class="card h-100">
            <div class="card-body table-responsive-md">
              <h3 style="margin-bottom: 0; margin-top: 15px">
                <span
                  >{{ texts.removeMember }} {{ data.firstName }}
                  {{ data.lastName }}</span
                >
              </h3>
              <span *ngIf="errorMessage" style="color: red">
                {{ errorMessage }}
              </span>
              <div class="container row my-4">
                <div class="col-lg-9 col-md-9 col-s-12 col-xs-12">
                  <span>{{ texts.confirmByLogin }}</span>
                  <br /><br />
                  <div class="form-group">
                    <label for="txtUsername">{{ texts.userName }}</label>
                    <span
                      *ngIf="
                        (userName.dirty || userName.touched) &&
                        userName.invalid &&
                        userName.errors.required
                      "
                      style="color: red"
                    >
                      {{ texts.userNameRequired }}
                    </span>
                    <input
                      type="text"
                      class="form-control"
                      id="txtUsername"
                      formControlName="userName"
                      placeholder="Username"
                      required
                      maxlength="50"
                      [class.is-invalid]="
                        (userName.dirty || userName.touched) &&
                        userName.invalid &&
                        userName.errors.required
                      "
                    />
                  </div>

                  <div class="form-group">
                    <label for="txtPassword">{{ texts.password }}</label>
                    <span
                      *ngIf="
                        (password.dirty || password.touched) &&
                        password.invalid &&
                        password.errors.required
                      "
                      style="color: red"
                    >
                      {{ texts.passwordRequired }}
                    </span>
                    <input
                      type="password"
                      class="form-control"
                      id="txtPassword"
                      formControlName="password"
                      placeholder="Password"
                      required
                      maxlength="50"
                      [class.is-invalid]="
                        (password.dirty || password.touched) &&
                        password.invalid &&
                        password.errors.required
                      "
                    />
                  </div>

                  <a
                    class="btn font-btn-small text-uppercase btn-outline-secondary mr-2 my-2"
                    (click)="cancel()"
                    >{{ texts.cancel }}</a
                  >

                  <button
                    class="btn font-btn-small text-uppercase btn-primary ml-2 my-2"
                    [disabled]="!memberForm.valid"
                    [ngClass]="cssColor + '-inv'"
                    type="submit"
                  >
                    {{ texts.validate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</ng-template>
